<breadcrumbs
  [breadcrumbs]="[
    { label: 'ADMIN', url: '/admin' },
    { label: 'USERS', url: '/admin/users' },
    { label: 'CREATE_USER' }
  ]"
></breadcrumbs>

<page-header title="CREATE_USER"></page-header>

<card>
  <form
    class="form m-0"
    style="width: 600px; max-width: 100%"
    (submit)="onSubmit($event)"
  >
    <div class="columns mb-0">
      <div class="column pb-0">
        <div class="field">
          <label class="label" translationEditableDirective="FIRST_NAME">{{
            'FIRST_NAME' | translate
          }}</label>
          <div class="control">
            <input
              class="input is-small"
              name="firstName"
              type="text"
              (input)="handleFieldChange($event)"
              placeholder="e.g Alex"
              [value]="getField(['firstName'])"
              [ngClass]="{ 'is-danger': hasError('firstName') }"
            />
          </div>
          <p class="help is-danger" *ngIf="hasError('firstName')">
            {{ getError('firstName') }}
          </p>
        </div>
      </div>

      <div class="column pb-0">
        <div class="field">
          <label class="label" translationEditableDirective="LAST_NAME">{{
            'LAST_NAME' | translate
          }}</label>
          <div class="control">
            <input
              class="input is-small"
              name="lastName"
              type="text"
              (input)="handleFieldChange($event)"
              placeholder="e.g Smith"
              [value]="getField(['lastName'])"
              [ngClass]="{ 'is-danger': hasError('lastName') }"
            />
          </div>
          <p class="help is-danger" *ngIf="hasError('lastName')">
            {{ getError('lastName') }}
          </p>
        </div>
      </div>
    </div>

    <div class="columns mb-0">
      <div class="column pb-0">
        <div class="field">
          <label class="label" translationEditableDirective="EMAIL">{{
            'EMAIL' | translate
          }}</label>
          <div class="control">
            <input
              class="input is-small"
              type="email"
              name="email"
              (input)="handleFieldChange($event)"
              placeholder="e.g. alexsmith@gmail.com"
              [value]="getField(['email'])"
              [ngClass]="{ 'is-danger': hasError('email') }"
            />
          </div>
          <p class="help is-danger" *ngIf="hasError('email')">
            {{ getError('email') }}
          </p>
        </div>
      </div>
      <div class="column pb-0">
        <div class="field">
          <label class="label" translationEditableDirective="PASSWORD">{{
            'PASSWORD' | translate
          }}</label>
          <div class="control">
            <input
              class="input is-small"
              (input)="handleFieldChange($event)"
              type="password"
              name="password"
              [value]="getField(['password'])"
              [ngClass]="{ 'is-danger': hasError('password') }"
            />
          </div>
          <p class="help is-danger" *ngIf="hasError('password')">
            {{ getError('password') }}
          </p>
        </div>
      </div>
    </div>

    <div class="columns">
      <div class="column pb-0">
        <div class="field">
          <label class="label" translationEditableDirective="ROLE">{{
            'ROLE' | translate
          }}</label>
          <div class="control">
            <ng-select
              [items]="roles"
              [multiple]="true"
              [closeOnSelect]="false"
              (change)="handleFieldChange($event, 'roles')"
              [ngClass]="{ 'is-danger': hasError('roles') }"
              bindLabel="title"
              class="is-small"
            >
            </ng-select>
          </div>
          <p class="help is-danger" *ngIf="hasError('roles')">
            {{ getError('roles') }}
          </p>
        </div>
      </div>
      <div class="column pb-0">
        <div class="field">
          <label
            class="label"
            translationEditableDirective="FINANCIAL_INSTITUTION"
            >{{ 'FINANCIAL_INSTITUTION' | translate }}</label
          >
          <div class="control">
            <ng-select
              [items]="financialInstitutions"
              [multiple]="false"
              [closeOnSelect]="true"
              (change)="handleFieldChange($event?.id, 'financialInstitutionId')"
              [ngClass]="{ 'is-danger': hasError('financialInstitutionId') }"
              [ngModel]="getField(['financialInstitutionId'])"
              [ngModelOptions]="{ standalone: true }"
              bindLabel="name"
              bindValue="id"
              [typeahead]="onFinancialInstitutionAutocomplete$"
              class="is-small"
            >
            </ng-select>
          </div>
          <p class="help is-danger" *ngIf="hasError('financialInstitutionId')">
            {{ getError('financialInstitutionId') }}
          </p>
        </div>
      </div>
    </div>
  </form>
</card>
<div class="field is-grouped px-3">
  <div class="control">
    <button
      [disabled]="isLoading"
      type="submit"
      class="button is-success"
      translationEditableDirective="SUBMIT"
      (click)="onSubmit($event)"
    >
      {{ 'SUBMIT' | translate }}
    </button>
  </div>
  <div class="control">
    <a
      [routerLink]="['/admin/users']"
      class="button is-link is-light"
      translationEditableDirective="CANCEL"
      >{{ 'CANCEL' | translate }}</a
    >
  </div>
</div>
